"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyProfileUpdateSchema = exports.CompanyProfileCreateSchema = void 0;
const company_schema_1 = require("./company.schema");
exports.CompanyProfileCreateSchema = company_schema_1.CompanyProfileSchema;
exports.CompanyProfileUpdateSchema = company_schema_1.CompanyProfileSchema.partial();
